export default "__VITE_ASSET__Ca1a2sH6__"